import React, { Component } from "react";
import { Switch, Route } from "react-router-dom";
import toyotaServices from "./services/toyotaServices.js";
import adesisServices from "./services/adesisServices.js";
import wearPiecesServices from "./services/wearPiecesServices.js";
import "./App.scss";
// import "./bootstrap.min.css"
// import "./main2.js"
// import "./app.component.css"
import "./dos-columnas.component.css"
import "./modulo-sugerencias.component.css"
import "./styles.css"
// import "./clientlib-lexus.css"
import Models from "./data/models.json";
import AppBar from "./components/AppBar";
import Map from "./components/Map/Map/index.js";
import CarRegistration from "./components/CarRegistration";
import ModelSelector from "./components/ModelSelector/ModelSelector";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Calculator from "./components/Calculator/Calculator";
import Print from "./components/Print/Print";
import Banner from "./components/Banner/Banner";
import DealersInfo from "./components/Map/DealersInfo/index.js";
import Searcher from "./components/Map/Searcher/index.js";
class App extends Component {
  constructor() {
    super();
    this.state = {
      redirectToInit: true,
      redirectToCalculator: false,
      appBarState1: 1,
      appBarState2: 0,
      appBarState3: 0,
      appBarState4: 0,
      resetCarFeatures: false,
      maintenanceCost: 0,
      precioNoIncluyeAdblue: false,
      wearPartsCost: 0,
      pieces: {
        0: false,
        1: false,
        2: false,
        3: false,
        4: false,
        5: false,
        6: false,
        7: false,
      },
    };
    this.toyotaServices = new toyotaServices();
    this.adesisServices = new adesisServices();
    this.wearPiecesServices = new wearPiecesServices();
  }

  componentWillMount() {
    this.getAllCarsInfo();
  }

  setRedirectToInit = () => {
    this.setState({
      ...this.state,
      redirectToInit: false,
      wearPiecesInfo: undefined,
      redirectToCalculator: false,
    });
  };

  getAllCarsInfo = async () => {
    // this.toyotaServices.getAllCarsInfo().then((allCarsInfo) => {
    //   this.setState({ ...this.state, allCarsInfo: allCarsInfo.data });
    // });

    var allCarsInfo = await this.toyotaServices.getAllCarsInfo()
    this.setState({ ...this.state, allCarsInfo });
  };

  setAppBarState = (state1, state2, state3, state4) => {
    this.setState({
      ...this.state,
      appBarState1: state1,
      appBarState2: state2,
      appBarState3: state3,
      appBarState4: state4,
    });
  };

  getWorkshopSelect = (workshop) => {
    // this.adesisServices
    //   .getUnitHourPrice(workshop.nIdConcesionario, workshop.nIdLocalizacion)
    //   .then((response) => {
    //     workshop.unitHourPrice = response.data.Data;
    //     this.setState({
    //       ...this.state,
    //       selectedWorkshops: workshop,
    //     });
    //   });

    this.adesisServices
      .getUnitHourPrice(workshop.DealershipId)
      .then((response) => {
        workshop.unitHourPrice = response.data.Data;

        console.log('workshop: ', workshop)
        this.setState({
          ...this.state,
          selectedWorkshops: workshop,
        });
      });
  };

  getWorkshopUrl = (workshopUrl) => {
    this.adesisServices
      .getWorkshopsbyUrl(workshopUrl.dealerId)
      .then((response) => {
        workshopUrl.dealerData = response.data.Data;
        console.log(workshopUrl.dealerData);
        this.setState({
          ...this.state,
          selectedWorkshops: workshopUrl,
        });
      });
  };

  getModelSelect = (model, typeId) => {
    let fuelSelected;
    typeId === 6
      ? (fuelSelected = "Híbrido")
      : model.fuelTypes.length === 1
      ? (fuelSelected = model.fuelTypes[0])
      : (fuelSelected = undefined);
    this.setState({
      ...this.state,
      selectedModel: model,
      fuelSelected,
      redirectToCalculator: true,
    });
  };

  getModelByRegistration = (model) => {
    this.setState({
      ...this.state,
      selectedModel: model,
    });
  };

  getCarByRegistration = (plate) => {
    let yearIntervalError = false;
    let carInformation;
    let selectedModel;
    let distanceOptions = [];
    this.resetNotFoundPlateMsg();

    let notValidPlate = "4102fsx";

    if (plate !== notValidPlate) {
      this.toyotaServices.getCarByRegistration(plate).then((carInfo) => {
        if (carInfo.data.exist) {
          this.state.allCarsInfo.forEach((modelClass, i) => {
            modelClass.lst.forEach((model, i) => {
              if (
                model.modelCode === carInfo.data.modelCode &&
                model.year === carInfo.data.year
              ) {
                model.rangeCode = modelClass.rangeCode;
                carInformation = model;
              }
            });
          });

          Models.forEach((possibleModel) => {
            if (possibleModel.rangeCode === carInformation.rangeCode)
              selectedModel = possibleModel;
          });
          
          this.adesisServices
            .getFuel([carInformation.fullKatashiki])
            .then((response) => {
              carInformation.fuel = response.data.Data[0].sCombustible;
            });
          console.log("carInformation", carInformation);
          this.adesisServices
            .getKmMantenimiento(
              carInformation.fullKatashiki,
              carInformation.gearBoxName,
              carInformation.year,
              carInformation.engineName
            )
            .then((response) => {
              if (response.data.Data === "") {
                yearIntervalError = true;
                console.log("2" + yearIntervalError);
              } else {
                let yearInterval = parseInt(response.data.Data);
                yearIntervalError = false;
                for (let i = 0; i < 12; i++) {
                  i === 0
                    ? distanceOptions.push(`${yearInterval}.000 km o 1 año`)
                    : distanceOptions.push(
                        `${(i + 1) * yearInterval}.000 km o ${i + 1} años`
                      );
                }
              }
              this.setState(
                {
                  ...this.state,
                  carInfo: carInformation,
                  yearIntervalError,
                  redirectToCalculator: true,
                  plate,
                  distanceOptions,
                  selectedModel,
                },
                () => {
                  // this.getWearPiecesByRegistration(plate);
                }
              );
            });
        }
        if (!carInfo.data.exist) {
          this.setState({
            ...this.state,
            notFoundPlateMsg: true,
            loading: false,
          });
        }
      });
    } else {
      this.setState({
        ...this.state,
        notFoundPlateMsg: true,
        loading: false,
      });
    }
  };

  resetNotFoundPlateMsg = () => {
    this.setState({ ...this.state, notFoundPlateMsg: false, loading: true });
  };

  getWearPiecesByRegistration = (plate) => {
    let wearPiecesInfo = {};
    this.setState({ ...this.state, notFoundPlatePiecesMsg: false }, () => {
      this.wearPiecesServices.getFrameNumber(plate).then((frameNumber) => {
        if (frameNumber.data !== "") {
          this.wearPiecesServices
            .getWearPiecesByFrameNumber(frameNumber)
            .then((response) => {
              response.forEach((part, i) => {
                let totalTime = 0;
                let totalPrice = 0;
                if (part.data.partsListField) {
                  part.data.operationsListField.forEach((operation, i) => {
                    totalTime += operation.operationTimeHoursField;
                  });
                  part.data.partsListField.forEach((part, i) => {
                    totalPrice += part.totalField;
                  });
                  if (totalPrice !== 0) {
                    let totalField =
                      totalTime *
                        this.state.selectedWorkshops.unitHourPrice *
                        1.21 +
                      totalPrice * 1.21;
                    wearPiecesInfo[i] = { totalField };
                  } else {
                    wearPiecesInfo[i] = { pieceNotAvailable: true };
                  }
                } else {
                  wearPiecesInfo[i] = { pieceNotAvailable: true };
                }
              });
              this.setState({
                ...this.state,
                wearPiecesInfo,
                wearPiecesPlate: plate,
              });
            });
        } else {
          this.setState({ ...this.state, notFoundPlatePiecesMsg: true });
        }
      });
    });
  };

  // hideAllToPrintToggle = () => {
  //   this.setState(
  //     {
  //       ...this.state,
  //       hideAllToPrint: !this.state.hideAllToPrint
  //     },
  //     () => {
  //       setTimeout(() => {
  //         this.setState({ ...this.state, hideAllToPrint: false });
  //       }, 100);
  //     }
  //   );
  // };

  getCarFeaturesValues = (name, value) => {
    this.setState({ ...this.state, [name]: value });
  };

  resetModels = () => {
    this.setState(
      {
        ...this.state,
        distanceOptions: undefined,
        distanceSelected: undefined,
        engineNameSelected: undefined,
        fuelSelected: undefined,
        yearSelected: undefined,
        gearBoxNameSelected: undefined,
        carInfo: undefined,
        selectedModel: undefined,
        redirectToCalculator: false,
        loading: false,
        plate: undefined,
        wearPiecesPlate: undefined,
        maintenanceCost: 0,
        precioNoIncluyeAdblue: false,
        wearPartsCost: 0,
        pieces: {
          0: false,
          1: false,
          2: false,
          3: false,
          4: false,
          5: false,
          6: false,
          7: false,
        },
        wearPiecesInfo: undefined,
      },
      () => {
        this.setAppBarState(2, 1, 0, 0);
      }
    );
  };

  resetRedirect = () => {
    this.setState({
      ...this.state,
      redirectToCalculator: false,
      fuelSelected: undefined,
      yearIntervalError: false,
    });
  };

  redirectToFalse = () => {
    this.setState({ ...this.state, redirectToCalculator: false });
  };

  resetStateTo1 = () => {
    this.setState({
      ...this.state,
      distanceSelected: undefined,
      engineNameSelected: undefined,
      fuelSelected: undefined,
      yearSelected: undefined,
      gearBoxNameSelected: undefined,
      carInfo: undefined,
      selectedModel: undefined,
      selectedWorkshops: undefined,
      loading: false,
      wearPiecesPlate: undefined,
      plate: undefined,
      maintenanceCost: 0,
      precioNoIncluyeAdblue: false,
      wearPartsCost: 0,
      pieces: {
        0: false,
        1: false,
        2: false,
        3: false,
        4: false,
        5: false,
        6: false,
        7: false,
      },
      wearPiecesInfo: undefined,
    });
  };

  resetStateTo2 = () => {
    this.setState(
      {
        ...this.state,
        distanceSelected: undefined,
        engineNameSelected: undefined,
        fuelSelected: undefined,
        yearSelected: undefined,
        gearBoxNameSelected: undefined,
        carInfo: undefined,
        maintenanceCost: 0,
        wearPartsCost: 0,
        loading: false,
        pieces: {
          0: false,
          1: false,
          2: false,
          3: false,
          4: false,
          5: false,
          6: false,
          7: false,
        },
        wearPiecesInfo: undefined,
        wearPiecesPlate: undefined,
      },
      () => {
        this.setAppBarState(2, 2, 1, 0);
      }
    );
  };

  getBudgetToApp = (budget) => {
    console.log(budget);
    this.setState({
      ...this.state,
      maintenanceCost: budget.dCosteMantenimiento,
      thingsToDo: budget.TiposMantenimientos,
      precioNoIncluyeAdblue: budget.bPrecioNoIncluyeAdblue,
    });
  };

  addTogglePiece = (id) => {
    this.setState(
      (prevState) => ({
        pieces: {
          ...prevState.pieces,
          [id]: !this.state.pieces[id],
        },
      }),
      () => {
        this.wearPartsCalculator(id);
      }
    );
  };

  wearPartsCalculator = (id) => {
    this.state.pieces[id]
      ? this.setState({
          ...this.state,
          wearPartsCost:
            this.state.wearPartsCost + this.state.wearPiecesInfo[id].totalField,
        })
      : this.setState({
          ...this.state,
          wearPartsCost:
            this.state.wearPartsCost - this.state.wearPiecesInfo[id].totalField,
        });
  };

  render() {
    return (
      <div className="App">
        <div className="hideToPrint">
          <Banner />
          <Header />
          <AppBar
            appBarState1={this.state.appBarState1}
            appBarState2={this.state.appBarState2}
            appBarState3={this.state.appBarState3}
            appBarState4={this.state.appBarState4}
            selectedWorkshops={this.state.selectedWorkshops}
            selectedModel={this.state.selectedModel}
            resetModels={this.resetModels}
            redirectToCarRegistartion={this.state.redirectToCarRegistartion}
            plate={this.state.plate}
            carInfo={this.state.carInfo}
            fuelSelected={this.state.fuelSelected}
            gearBoxNameSelected={this.state.gearBoxNameSelected}
            engineNameSelected={this.state.engineNameSelected}
            yearSelected={this.state.yearSelected}
            distanceSelected={this.state.distanceSelected}
            resetCarFeaturesToggle={this.resetCarFeaturesToggle}
            resetStateTo1={this.resetStateTo1}
            resetStateTo2={this.resetStateTo2}
          />
          
          {this.state.allCarsInfo ? (
            <div className="wrapper">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-12 map-full">
                    {/* col-12 */}
                    <div id="patch" />
                    <Switch>
                      <Route
                        exact
                        path="/"
                        render={() => (
                          <div>
                            {/* <WorkshopSearch
                            getWorkshopSelect={this.getWorkshopSelect}
                            setAppBarState={this.setAppBarState}
                            setRedirectToInit={this.setRedirectToInit}
                            resetStateTo1={this.resetStateTo1}
                          /> */}

                            <div className="map">
                              <div>
                                <Map
                                  getWorkshopSelect={this.getWorkshopSelect}
                                  setRedirectToInit={this.setRedirectToInit}
                                />
                              </div>
                              <div className="search-dealers">
                                <Searcher />
                                <DealersInfo
                                  getWorkshopSelect={this.getWorkshopSelect}
                                  setRedirectToInit={this.setRedirectToInit}
                                  resetStateTo1={this.resetStateTo1}
                                  setAppBarState={this.setAppBarState}
                                />
                              </div>
                            </div>
                          </div>
                        )}
                      />

                      <Route
                        exact
                        path="/carRegistration"
                        render={() => (
                          <CarRegistration
                            redirectToInit={this.state.redirectToInit}
                            getCarByRegistration={this.getCarByRegistration}
                            redirectToCalculator={
                              this.state.redirectToCalculator
                            }
                            redirectToFalse={this.redirectToFalse}
                            setAppBarState={this.setAppBarState}
                            notFoundPlateMsg={this.state.notFoundPlateMsg}
                            getWearPiecesByRegistration={
                              this.getWearPiecesByRegistration
                            }
                            loading={this.state.loading}
                            resetModels={this.resetModels}
                          />
                        )}
                      />
                      <Route
                        exact
                        path="/modelSelector"
                        render={() => (
                          <ModelSelector
                            redirectToInit={this.state.redirectToInit}
                            getModelSelect={this.getModelSelect}
                            setAppBarState={this.setAppBarState}
                            redirectToCalculator={
                              this.state.redirectToCalculator
                            }
                            getFuelIfIsHybrid={this.getFuelIfIsHybrid}
                            resetModels={this.resetModels}
                          />
                        )}
                      />
                      <Route
                        exact
                        path="/calculator"
                        render={() => (
                          <Calculator
                            addTogglePiece={this.addTogglePiece}
                            getBudgetToApp={this.getBudgetToApp}
                            fuelSelected={this.state.fuelSelected}
                            gearBoxNameSelected={this.state.gearBoxNameSelected}
                            engineNameSelected={this.state.engineNameSelected}
                            yearSelected={this.state.yearSelected}
                            distanceSelected={this.state.distanceSelected}
                            getCarFeaturesValues={this.getCarFeaturesValues}
                            // hideAllToPrintToggle={this.hideAllToPrintToggle}
                            // notFoundPlateMsg={this.state.notFoundPlateMsg}
                            notFoundPlatePiecesMsg={
                              this.state.notFoundPlatePiecesMsg
                            }
                            carInfo={this.state.carInfo}
                            selectedModel={this.state.selectedModel}
                            allCarsInfo={this.state.allCarsInfo}
                            resetRedirect={this.resetRedirect}
                            getCarByRegistration={this.getCarByRegistration}
                            setAppBarState={this.setAppBarState}
                            getModelByRegistration={this.getModelByRegistration}
                            getWearPiecesByRegistration={
                              this.getWearPiecesByRegistration
                            }
                            redirectToFalse={this.redirectToFalse}
                            wearPiecesInfo={this.state.wearPiecesInfo}
                            getDatosToPrint={this.getDatosToPrint}
                            distanceOptions={this.state.distanceOptions}
                            plate={this.state.plate}
                            selectedWorkshops={this.state.selectedWorkshops}
                            resetCarFeatures={this.state.resetCarFeatures}
                            resetCarFeaturesToggle={this.resetCarFeaturesToggle}
                            loading={this.state.loading}
                            maintenanceCost={this.state.maintenanceCost}
                            precioNoIncluyeAdblue={
                              this.state.precioNoIncluyeAdblue
                            }
                            wearPartsCost={this.state.wearPartsCost}
                            thingsToDo={this.state.thingsToDo}
                            pieces={this.state.pieces}
                            yearIntervalError={this.state.yearIntervalError}
                            // model={this.props.selectedModel}
                          />
                        )}
                      />
                    </Switch>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="loader" style={{ marginTop: 50 }}>
              <img width="50"
                className="gif-desktop"
                src="images/spinner.gif"
                alt="loader"
              />
              {/* <img
                className="gif-mobile"
                src="images/MB-animacion-loader.gif"
                alt="loader"
              /> */}
              <img
                width="50"
                className="gif-mobile"
                src="images/spinner.gif"
                alt="loader"
              />
            </div>
          )}
          <Footer />
        </div>
        {/* {this.state.hideAllToPrint && this.state.thingsToDo ? ( */}

        {this.state.selectedWorkshops && this.state.selectedModel && (
          <Print
            // hideAllToPrint={this.state.hideAllToPrint}
            selectedWorkshops={this.state.selectedWorkshops}
            maintenanceCost={this.state.maintenanceCost}
            wearPartsCost={this.state.wearPartsCost}
            pieces={this.state.pieces}
            wearPiecesInfo={this.state.wearPiecesInfo}
            wearPiecesPlate={this.state.wearPiecesPlate}
            carInfo={this.state.carInfo}
            fuelSelected={this.state.fuelSelected}
            gearBoxNameSelected={this.state.gearBoxNameSelected}
            engineNameSelected={this.state.engineNameSelected}
            yearSelected={this.state.yearSelected}
            distanceSelected={this.state.distanceSelected}
            selectedModel={this.state.selectedModel}
            thingsToDo={this.state.thingsToDo}
            precioNoIncluyeAdblue={this.state.precioNoIncluyeAdblue}
          />
        )}

        {/* ) : null} */}
      </div>
    );
  }
}

export default App;
